import { render, staticRenderFns } from "./PostPreviewCompact.vue?vue&type=template&id=00a92b2a&scoped=true&"
import script from "./PostPreviewCompact.vue?vue&type=script&lang=js&"
export * from "./PostPreviewCompact.vue?vue&type=script&lang=js&"
import style0 from "./PostPreviewCompact.vue?vue&type=style&index=0&id=00a92b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a92b2a",
  null
  
)

export default component.exports